import { render, staticRenderFns } from "./SimpleDialog.vue?vue&type=template&id=5b9f981e&scoped=true&"
import script from "./SimpleDialog.vue?vue&type=script&lang=js&"
export * from "./SimpleDialog.vue?vue&type=script&lang=js&"
import style0 from "./SimpleDialog.vue?vue&type=style&index=0&id=5b9f981e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9f981e",
  null
  
)

export default component.exports